import Vue from 'vue'
Vue.component('AsideMenu', () => import('./plantilla/AsideMenu.vue'))
Vue.component('Header', () => import('./plantilla/Header.vue'))
Vue.component('BarraAvance', () => import('./plantilla/BarraAvance.vue'))
Vue.component('BannerInterno', () => import('./plantilla/BannerInterno.vue'))
Vue.component('Accesibilidad', () => import('./plantilla/Accesibilidad.vue'))

Vue.component('AcordionA', () => import('./AcordionA.vue'))
Vue.component('TabsA', () => import('./TabsA.vue'))
Vue.component('TabsB', () => import('./TabsB.vue'))
Vue.component('TabsC', () => import('./TabsC.vue'))
Vue.component('LineaTiempoA', () => import('./LineaTiempoA.vue'))
Vue.component('LineaTiempoB', () => import('./LineaTiempoB.vue'))
Vue.component('LineaTiempoC', () => import('./LineaTiempoC.vue'))
Vue.component('LineaTiempoD', () => import('./LineaTiempoD.vue'))
Vue.component('LineaTiempoE', () => import('./LineaTiempoE.vue'))
Vue.component('PasosA', () => import('./PasosA.vue'))
Vue.component('PasosB', () => import('./PasosB.vue'))
Vue.component('SlyderA', () => import('./SlyderA.vue'))
Vue.component('SlyderB', () => import('./SlyderB.vue'))
Vue.component('SlyderC', () => import('./SlyderC.vue'))
Vue.component('SlyderD', () => import('./SlyderD.vue'))
Vue.component('SlyderE', () => import('./SlyderE.vue'))
Vue.component('SlyderF', () => import('./SlyderF.vue'))
Vue.component('ModalA', () => import('./ModalA.vue'))
Vue.component('ImagenInfografica', () => import('./ImagenInfografica.vue'))
Vue.component('ImagenInfograficaB', () => import('./ImagenInfograficaB.vue'))
Vue.component('Separador', () => import('./Separador.vue'))
Vue.component('Zoom', () => import('./Zoom.vue'))
Vue.component('Audio', () => import('./Audio.vue'))
Vue.component('TarjetaAudio', () => import('./TarjetaAudio.vue'))
Vue.component('Dialogo', () => import('./Dialogo.vue'))
Vue.component('DialogoBurbuja', () => import('./DialogoBurbuja.vue'))
Vue.component('DialogoActividad', () => import('./DialogoActividad.vue'))
Vue.component('Actividad', () => import('./actividad/Actividad.vue'))
Vue.component('DownloadCard', () => import('./DownloadCard.vue'))
